import { AlertError, Button, Modal, TextArea } from '@percihealth/react';
import { useEffect, useMemo, useState } from 'react';
import { CasesSupportAuthorizationApiRepository } from '../../../../../api';
import { useFirebase } from '../../../../../context';

interface Props {
  caseId: string;
  open: boolean;
  onClose: () => void;
}

export const SupportAuthorizationNotRequiredModal = ({
  caseId,
  open,
  onClose,
}: Props) => {
  const { auth } = useFirebase();
  const endOfSupportApiRepository = useMemo(
    () => new CasesSupportAuthorizationApiRepository(auth),
    [auth],
  );
  const [notes, setNotes] = useState('');

  const [submitting, setSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  useEffect(() => {
    setErrorMessage(null);
    setSubmitting(false);
    setNotes('');
  }, [caseId, open]);

  const notRequired = async () => {
    setSubmitting(true);
    setErrorMessage(null);
    try {
      await endOfSupportApiRepository.authorizationNotRequired(caseId, notes);
      onClose();
    } catch (error) {
      console.error(error);
      setErrorMessage((error as Error).message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose} center>
      <h3>Pre-authorization not required</h3>
      <p>
        No need in support extension pre-authorization for the case{' '}
        <b>{caseId}</b>?
      </p>
      <TextArea
        label="Notes (optional)"
        value={notes}
        onChange={(e) => setNotes(e.target.value)}
        rows={3}
      />
      <br />
      {errorMessage && <AlertError>{errorMessage}</AlertError>}
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Button onClick={onClose} disabled={submitting}>
          Abort
        </Button>

        <Button
          level="secondary"
          submitting={submitting}
          onClick={async () => {
            await notRequired();
          }}
        >
          Confirm
        </Button>
      </div>
    </Modal>
  );
};
